var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellularFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0832 11.1667L15.2915 12.375C15.6109 12.0556 15.854 11.691 16.0207 11.2813C16.1873 10.8716 16.2707 10.4445 16.2707 10C16.2707 9.5556 16.1873 9.12851 16.0207 8.71879C15.854 8.30907 15.6109 7.94448 15.2915 7.62504L14.0832 8.83337C14.2498 8.98615 14.3783 9.16323 14.4686 9.36462C14.5589 9.56601 14.604 9.77782 14.604 10C14.604 10.2223 14.5589 10.4341 14.4686 10.6355C14.3783 10.8368 14.2498 11.0139 14.0832 11.1667Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 13.25L17.3332 14.4167C17.9304 13.8334 18.3887 13.1598 18.7082 12.3959C19.0276 11.632 19.1873 10.8334 19.1873 10C19.1873 9.16671 19.0276 8.3681 18.7082 7.60421C18.3887 6.84032 17.9304 6.16671 17.3332 5.58337L16.1665 6.75004C16.5971 7.1806 16.9304 7.67365 17.1665 8.22921C17.4026 8.78476 17.5207 9.37504 17.5207 10C17.5207 10.625 17.4026 11.2153 17.1665 11.7709C16.9304 12.3264 16.5971 12.8195 16.1665 13.25Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65609 18.6771C4.98248 19.0035 5.37484 19.1667 5.83317 19.1667H14.1665C14.6248 19.1667 15.0172 19.0035 15.3436 18.6771C15.67 18.3507 15.8332 17.9584 15.8332 17.5V16.6164L14.1665 14.9495V15H5.83317V6.61533L4.1665 4.94849V17.5C4.1665 17.9584 4.3297 18.3507 4.65609 18.6771ZM5.83317 17.5V16.6667H14.1665V17.5H5.83317Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1665 3.20035V2.50004C4.1665 2.04171 4.3297 1.64935 4.65609 1.32296C4.98248 0.996568 5.37484 0.833374 5.83317 0.833374H14.1665C14.6248 0.833374 15.0172 0.996568 15.3436 1.32296C15.67 1.64935 15.8332 2.04171 15.8332 2.50004V5.83337H14.1665V5.00004H5.96601L4.1665 3.20035ZM14.1665 3.33337H5.83317V2.50004H14.1665V3.33337Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31104 3.75911L2.18343 2.88346L17.8084 18.5101L16.9352 19.3849L1.31104 3.75911Z",
    fill: "#FF7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularFailed);
export default __webpack_public_path__ + "static/media/cellular_failed.542a9fb3f46cafc7ffa84247ecd383d8.svg";
export { ForwardRef as ReactComponent };